import React, { useState, useContext } from "react"
import { handleFormSubmission } from "../../../handlers"
import { VStack, Flex } from "@chakra-ui/react"
import { FormContext } from "../../../contexts"
import { useForm } from "react-hook-form"

import FormSubject from "./FormSubject"
import FormMessage from "./FormMessage"
import FormSubmit from "./FormSubmit"
import FormEmail from "./FormEmail"
import FormPhone from "./FormPhone"
import FormName from "./FormName"

export function Form() {
  const {
    formState: { errors },
    handleSubmit,
    register,
  } = useForm({
    reValidateMode: "onChange",
    mode: "onSubmit",
  })

  const { subject, updateSubject } = useContext(FormContext)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [success, setSuccess] = useState(null)

  const onSubmit = (values, evt) => {
    evt.preventDefault()
    setIsSubmitting(true)

    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: handleFormSubmission({ "form-name": "contact", ...values }),
    })
      .then(() => {
        setSuccess(true)
        setIsSubmitting(false)
        updateSubject("")
        evt.target.reset()

        setTimeout(() => setSuccess(null), 3000)
      })
      .catch(() => {
        setSuccess(false)
        updateSubject("")
        evt.target.reset()

        setTimeout(() => setSuccess(null), 3000)
      })
  }

  const formProps = {
    onSubmit: handleSubmit(onSubmit),
    "data-netlify-honeypot": "bot-field",
    "data-netlify": "true",
    direction: "column",
    name: "contact",
    method: "post",
    width: "100%",
    mx: "auto",
    as: "form",
  }

  const nameProps = {
    error: errors.name,
    register,
    success,
  }

  const emailProps = {
    error: errors.email,
    register,
    success,
  }

  const phoneProps = {
    error: errors.phone,
    register,
    success,
  }

  const subjectProps = {
    error: errors.subject,
    updateSubject,
    register,
    subject,
    success,
  }

  const messageProps = {
    error: errors.message,
    register,
    success,
  }

  const submitProps = {
    isSubmitting,
    success,
  }

  return (
    <Flex {...formProps}>
      {/* Hidden input for Netlify to reference the form */}
      <input type="hidden" name="form-name" value="contact" />

      <VStack spacing={6} mb={6}>
        <FormName {...nameProps} />
        <FormEmail {...emailProps} />
        <FormPhone {...phoneProps} />
        <FormSubject {...subjectProps} />
        <FormMessage {...messageProps} />
      </VStack>

      <FormSubmit {...submitProps} />
    </Flex>
  )
}
